import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    earningMetricData: {
        noOfOrder: "N/A",
        totalSales: "N/A",
        totalCommission: "N/A",
        avgOrderValue: "N/A",
        creatorCommision: "N/A",
        animetaCommision: "N/A",
        clicks: "N/A"
    },
}

const salesCommissionSlice = createSlice({
    name: "salesCommission",
    initialState,
    reducers: {
        setEarningMetrics(state, action) {
            state.earningMetricData = action.payload.earningMetricData
        },
        clearSalesCommisstion(action, state) {
            return initialState
        },
    }
})

export const { setEarningMetrics } = salesCommissionSlice.actions;
export const salesActions = salesCommissionSlice.actions;
export default salesCommissionSlice;